export const ROLES = [
    'Admin',
    'Personal',
    'GF',
    'Lehrling'
];
